module.exports = __webpack_public_path__ + "img/telegram.95bebf3a.png";